import { ChevronRight } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { TListHook } from "../../@types/common";
import { VIEW_ALL } from "../../constants/constants";
import useGet from "../../hooks/common/useGet";
import { listHooks } from "../../hooks/handlers/registerHooks";
import { stringify } from "../../utils/helpers";
import { SimpleLoader } from "../common/Loader";
import { EmptyView } from "../elements/Elements";

export const HorizontalList = ({ source }: { source: string }) => {
  const hook = listHooks?.[source];
  const { title, ListItem, defaultValues, listRoute, api, params }: TListHook =
    hook ? hook() : {};
  const [list, setList] = useState(defaultValues || []);
  const listRef: any = useRef(null);

  const { loadData, loading } = useGet();

  // GET DATA
  const getData = () => {
    if (api)
      loadData({
        api,
        params: { ...params },
        onSuccess: (data: any) => setList(data?.results),
      });
  };

  useEffect(() => {
    getData();
  }, []);

  // useLoadingSimulator(setLoading);

  const scrollRight = () => {
    if (listRef.current) {
      const itemWidth = listRef.current.children[0]?.clientWidth || 0;
      const gap = 15; // matches gap in ListWrapper styled component
      listRef.current.scrollBy({
        left: itemWidth + gap,
        behavior: "smooth",
      });
    }
  };
  return (
    <Wrapper className="flexColumn gap15 hidden">
      <div className="flexSpaceCenter" style={{ padding: "0 15px" }}>
        <div className="semiBold capitalize">{stringify(title)}</div>
        <Link to={listRoute}>
          <div className="semiBold font13 main">{VIEW_ALL}</div>
        </Link>
      </div>
      {/* SLIDER */}

      {loading ? (
        <SimpleLoader />
      ) : list?.length > 0 ? (
        <div className="relative flexNullCenter">
          <ListWrapper className="flex gap15 scroll noScroll" ref={listRef}>
            {list?.map((v, i) => (
              <div
                key={i}
                data-aos="fade-left"
                data-aos-duration="1000"
                data-aos-delay={i * 100}
              >
                <ListItem data={v} key={i} summary={true} />
              </div>
            ))}
          </ListWrapper>

          <GradientWrapper />

          <ButtonWrapper
            className="p10 r20 mainBg white flexCenter absolute pointer animate"
            onClick={scrollRight}
          >
            <ChevronRight />
          </ButtonWrapper>
        </div>
      ) : (
        <EmptyView />
      )}
    </Wrapper>
  );
};

const ListWrapper = styled.div`
  padding-left: 15px;
  padding-right: 80px;
`;

const GradientWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 100px;
  pointer-events: none;

  background: linear-gradient(
    90deg,
    rgba(243, 245, 252, 0) 0%,
    rgba(244, 245, 252, 1) 70%
  );
`;

const ButtonWrapper = styled.div`
  height: 20px;
  width: 20px;
  right: 20px;

  &:hover {
    scale: 0.9;
  }
`;

const Wrapper = styled.div`
  margin: 0 -15px;
  max-width: 650px;

  @media (max-width: 960px) {
    width: 100vw;
  }
`;
